import {
    apiRequest,
    hukumanUpdate,
    hukumanDetail,
    hukumanListPegawai,
    hukumanListHukuman
} from "../../../../../services/adapters/kepegawaian/hukumanService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", hukumanUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", hukumanDetail, {
            params: query
        }, true)
    }

    fetchPegawai = async (query) => {
        return await apiRequest("get", hukumanListPegawai, {
            body: query
        }, true)
    }

    fetchHukuman = async (query) => {
        return await apiRequest("get", hukumanListHukuman, {
            body: query
        }, true)
    }
}

export default UpdateRepository